import { h, Component } from 'preact'

import { connect } from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'

import imageService from '../service/imageService'
import Spinner from './Spinner'
import Masonry from 'react-masonry-component'

import constants from "../constants";
import store from "../store";

import Cropper from "react-cropper";
import 'cropperjs/dist/cropper.min.css'
import util, { toLogIn } from '../util';

import moment from 'moment';
import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons'
import ADAIcon from './icon/ADAIcon';
import CropImageIcon from './icon/CropImageIcon';
import { Drawer } from 'antd'
import OrganizeUploadsModal from './OrganizeUploadsModal';
import FavoriteButton from './FavoriteButton'
import UploadImageCard from './card/UploadImageCard'

export default @connect(reduce, actions)
class AsideUploads extends Component {
  constructor() {
    super();
    this.state = {
      loadedImages: [],
      numLoaded: 0,
      batchSize: 30,
      isUploadLoading: false,
      isLoading: false,
      uploadErrMsg: '',

      isCropping: false,
      imageCropSrc: '',
      cropResult: null
    };

    this.auth = () => {
      toLogIn();
    }

    // Bind the methods that will be passed as props
    this.removeImage = this.removeImage.bind(this);
    this.openCropper = this.openCropper.bind(this);
    this.openAltTextModal = this.openAltTextModal.bind(this);
    this.closeOrganizeUploadsModal = this.closeOrganizeUploadsModal.bind(this);
  }

  componentDidMount() {
    this.setState({ numLoaded: this.state.batchSize });
    setTimeout(() => {
      this.setState({ loadedImages: this.props.uploadedImages.slice(0, this.state.numLoaded) });
    })
    this.addLoadListener();
  }

  addLoadListener() {
    const scrollerDiv = $('.aside-uploads>.scroller');
    const componentsDiv = $('.aside-uploads>.scroller>.components');
    scrollerDiv.on('scroll', () => {
      if (scrollerDiv.scrollTop() >= Math.floor(componentsDiv.height() - scrollerDiv.height())) {
        this.loadMore();
      }
    })
  }

  onChange(event) {
    const files = event.target.files;
    if (!files.length) return;

    let fileTypeValid = false;
    let fileType = files[0].type.toLowerCase();

    if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/gif' || fileType === 'video/mp4' || fileType === 'video/webm') {
      fileTypeValid = true;
    }

    if ((fileType === 'video/mp4' || fileType === 'video/webm') && !this.props.hasPdfPermission) {
      $('.input-file').val('');
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
      return;
    }

    if (!fileTypeValid) {
      window.InfoModal.show({
        title: 'File type not supported',
        body: 'Supported file types are .jpg, .png, .gif and .mp4.',
        acceptLabel: 'Got it',
      });
      return;
    }

    const isPhoto = (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/gif');
    let isSizeValid = true;
    let sizeLimit = isPhoto ? 10 : 50; // 10MB for photos, 50MB for videos
    let resolutionLimit = 10000;
    let max = sizeLimit * 1024 * 1024;

    for (let idx = 0; idx < files.length; idx++) {
      if (files[idx].size > max) {
        isSizeValid = false;
      }
    }

    if (!isSizeValid) {
      window.ConfirmationModal.show({
        title: 'File exceeds limit',
        body: "This image can\'t be uploaded because it exceeds the " + sizeLimit + " MB file size limit.",
        acceptLabel: 'Ok',
        hideDecline: true,
        onAccept: () => {
          window.ConfirmationModal.hide()
        }
      });

      return;
    }

    var fr = new FileReader;
    this.uploadImage(files);

    const $this = this;
    fr.onload = function () {
      if (fileType === 'video/mp4' || fileType === 'video/webm') {
        $this.uploadImage(files);
      } else {
        var img = new Image;
        img.onload = function () {
          if (img.naturalWidth > resolutionLimit || img.naturalWidth > resolutionLimit) {
            window.ConfirmationModal.show({
              title: 'File exceeds limit',
              body: `This image can't be uploaded because it exceeds the ${resolutionLimit}x${resolutionLimit} image resolution limit.`,
              acceptLabel: 'Ok',
              hideDecline: true,
              onAccept: () => {
                window.ConfirmationModal.hide()
              }
            });
            return;
          }
          $this.uploadImage(files);
        };
        img.src = fr.result;
      }
      fr.readAsDataURL(files[0]);
    }
  }

  uploadImage(files) {
    function cleanFileName(name) {
      return name.replaceAll('+', '');
    }

    const formData = new FormData();
    Array.from(Array(files.length).keys())
      .map(x => {
        formData.append('images', files[x], cleanFileName(files[x].name));
      });

    this.setState({
      isUploadLoading: true,
      isCropping: false,
      imageCropSrc: ''
    });

    formData.append("locationId", this.props.locationId);
    const promise = this.props.isLogged ?
      imageService.uploadMemberImage(this.props.memberId, formData) :
      imageService.uploadVisitorImage(this.props.visitorId, formData);

    promise.then(response => {
      const newImage = response.data;
      this.setState({ isUploadLoading: false });
      this.props.setUploadedImages([...newImage, ...this.props.uploadedImages]);
      this.setState({ numLoaded: this.state.numLoaded + 1 })
      setTimeout(() => {
        this.setState({ loadedImages: this.props.uploadedImages.slice(0, this.state.numLoaded) });
        store.dispatch(actions.setIsAltTextModal(true));
        store.dispatch(actions.setSelectedUploadedImage(newImage[0]));
        store.dispatch(actions.setIsJustUploaded(true));
      })
      if (this.props.isReplaceFrameMode) {
        setTimeout(() => {
          $('.masonry-grid .component.template').first().trigger('click');
        }, 1000)
      }
    }).catch(err => {
      this.setState({ isUploadLoading: false });
      if (!err.response || err.response.data.message) {
        let errMsg = '';
        const isMaxUploadErr = !err.response || err.response.data.message.indexOf('Maximum upload') > -1;

        if (isMaxUploadErr) {
          errMsg = "This image can\'t be uploaded because it exceeds the 50 MB file size limit.";

          window.ConfirmationModal.show({
            title: 'File exceeds limit',
            body: errMsg,
            acceptLabel: 'Ok',
            hideDecline: true,
            onAccept: () => {
              window.ConfirmationModal.hide()
            }
          })
        }
      }
    })
  }

  removeImage(image, event) {
    event.stopPropagation();
    const $this = this;

    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This image will be removed from your gallery.',
      acceptLabel: 'Ok',
      declineLabel: 'Cancel',
      onAccept: () => {
        imageService.removeMemberImage(image.id).then(response => {
          $this.props.setUploadedImages($this.props.uploadedImages.filter(it => it.id !== image.id))
          //this.setState({ allImages: this.state.allImages.filter(it => it.id !== image.id) })
          this.setState({ numLoaded: this.state.numLoaded - 1 })
          setTimeout(() => {
            $this.setState({ loadedImages: $this.props.uploadedImages.slice(0, $this.state.numLoaded) });
          })
        })
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    })
  }

  closeOrganizeUploadsModal() {
    const $this = this;

    store.dispatch(actions.hideOrganizeUploadsModal());
    $this.setState({ loadedImages: $this.props.uploadedImages.slice(0, $this.state.numLoaded) });
  }

  openCropper(image, event) {
    event.stopPropagation();
    const $this = this;

    const isOOS3 = image.source === 'oo';

    $this.setState({
      isCropping: true,
      imageCropSrc: isOOS3 ?
        constants.urlPrefix + '/api/image/s3/oo/' + image.id :
        constants.urlPrefix + '/api/image/s3/' + image.id
    })

    setTimeout(function () {
      /*if (store.getState().isMobileVersion) {
        $('.upload-cropper').parent().find('.scroller.no-top').css('z-index', '-1');
      }*/
      // weird cropper fix for mobile + safari
      $('.upload-cropper').css('display', 'none');
      setTimeout(function () {
        $('.upload-cropper').css('display', 'block');
      }, 100);
      $this.addLoadListener();
    }, 1000);
  }

  closeCropper() {
    const $this = this;
    $this.setState({
      isCropping: false,
      imageCropSrc: ''
    })
  }

  cropImage() {
    if (typeof this.cropper.cropper.getCroppedCanvas() === "undefined") {
      return
    }

    this.setState({
      cropResult: this.cropper.cropper.getCroppedCanvas().toDataURL()
    });

    this.cropper.cropper.getCroppedCanvas({
      maxWidth: 1024,
      maxHeight: 1024,
      imageSmoothingEnabled: 'false',
    }).toBlob((blob) => {
      if (blob) {
        const formData = new FormData();
        // Pass the image file name as the third parameter if necessary.
        formData.append('images', blob, util.UUID.get() + '_cropped.png');

        this.setState({ isUploadLoading: true });

        formData.append("locationId", this.props.locationId);
        imageService.uploadMemberImage(this.props.memberId, formData).then(response => {
          const newImage = response.data;
          this.setState({
            isUploadLoading: false,
            //allImages: [...response.data, ...this.state.allImages],
            isCropping: false,
            imageCropSrc: '',
            numLoaded: this.state.numLoaded + 1
          })
          this.props.setUploadedImages([...newImage, ...this.props.uploadedImages]);
          setTimeout(() => {
            this.setState({ loadedImages: this.props.uploadedImages.slice(0, this.state.numLoaded) });
            store.dispatch(actions.setIsAltTextModal(true));
            store.dispatch(actions.setSelectedUploadedImage(newImage[0]));
            store.dispatch(actions.setIsJustUploaded(true));
          })
        }).catch(() => {
          this.setState({ isUploadLoading: false });
        })
      }
    })
  }

  loadMore() {
    this.setState({ numLoaded: Math.min(this.state.numLoaded + this.state.batchSize, this.props.uploadedImages.length) });
    setTimeout(() => {
      this.setState({ loadedImages: this.props.uploadedImages.slice(0, this.state.numLoaded) });
    })
  }

  openAltTextModal(image, event) {
    event.stopPropagation();
    store.dispatch(actions.setIsAltTextModal(true));
    store.dispatch(actions.setSelectedUploadedImage(image));
  }

  handleMenuToggle(event) {
    const menuToggle = event.currentTarget;
    const dropdownMenu = menuToggle.nextElementSibling;
    const componentRect = menuToggle.closest('.component').getBoundingClientRect();
    const containerRect = document.querySelector('.masonry-grid').getBoundingClientRect();

    // Check if there's enough space on the right
    const spaceOnRight = containerRect.right - componentRect.right;
    // Assuming dropdown menu width is 150px, adjust this value as needed
    if (spaceOnRight < 150) {
      dropdownMenu.style.left = 'auto';
      dropdownMenu.style.right = '0';
    } else {
      dropdownMenu.style.left = '0';
      dropdownMenu.style.right = 'auto';
    }
  }

  openOrganizeUploadsModal() {
    store.dispatch(actions.showOrganizeUploadsModal());
  }

  toggleFavorite(image) {
    image.isFavorite = !image.isFavorite;
  }

  render(props, state) {
    let uploadBox = null;

    if (!props.isLogged) {
      uploadBox = <div>
        <p>This step requires an account</p>
        <a className="btn tertiary" onClick={this.auth}>Log In / Sign Up</a>
      </div>
    } else {
      if (state.isUploadLoading && !state.isCropping) {
        uploadBox = <Spinner />
      } else {
        uploadBox = <div>
          <input class="upload-image" type="file" name="image" onChange={this.onChange.bind(this)} accept="image/jpeg,image/png,image/gif,video/mp4,video/webm" className="input-file" multiple />
          <div>
            <p>Drag and drop files here or </p>
            <a className="btn primary medium">
              <span>Choose Media</span>
            </a>
          </div>
        </div>
      }
    }

    const uploadErrorMessage = state.uploadErrMsg ? <div className="upload-err">{state.uploadErrMsg}</div> : null;

    const imageLoadingSpinner = state.isLoading ? <Spinner /> : null;

    const elements = state.loadedImages.map(image => {
      if ((props.isReplaceFrameMode && util.isVideoFrame(props.$element) && (!image.isMp4 && !image.isWebM)) ||
        (props.isReplaceFrameMode && !util.isVideoFrame(props.$element) && (image.isMp4 || image.isWebM))) {
        return;
      }

      return <UploadImageCard
        image={image}
        uploadedImages={props.uploadedImages}
        setUploadedImages={props.setUploadedImages}
        openCropper={this.openCropper}
        openAltTextModal={this.openAltTextModal}
        isFavorite={image.isFavorite}
        toggleFavoriteCallback={() => this.toggleFavorite(image)}
        removeImageCallback={() => {
          this.setState({ loadedImages: this.props.uploadedImages.slice(0, this.state.numLoaded) });
        }}
      />

      // if (image.isMp4 || image.isWebM) {
      //   const component = <div className="component template video-frame" data-component="video-frame">
      //     <div className="frame" data-component="video-frame" data-type="video-frame" style="display: table-row;" data-asset-id={image.assetId}>
      //       <div className="video" style={`width: 100%; height: 100%;`} data-original-bg-video={util.getUploadedImgSrc(image)} role="img" aria-label={image.altText}
      //         dangerouslySetInnerHTML={{
      //           __html:
      //             `<video 
      //            loop muted disablepictureinpicture playsinline 
      //            src=${util.getUploadedImgSrc(image)}  
      //            style="width: 100%; height: 100%; object-fit: cover;" />`
      //         }} />

      //       <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
      //           <div className="dropdown menu-container">
      //             <div 
      //               className="dropdown-toggle menu-toggle"
      //               onClick={this.handleMenuToggle}
      //             >
      //               <EllipsisOutlined/>
      //             </div>
      //             <div className="dropdown-menu">
      //               <ul>
      //                 <li onClick={(event) => this.openAltTextModal(image, event)}>
      //                   <ADAIcon color="#000"/> ADA Text
      //                 </li>
      //                 <li onClick={(event) => this.removeImage(image, event)}>
      //                   <DeleteOutlined/> Delete
      //                 </li>
      //               </ul>
      //             </div>
      //           </div>
      //         </div>
      //     </div>
      //   </div>

      //   return (component);
      // } else {
      //   return (
      //     <div className="component template frame" data-component="frame">
      //       <div className="frame" data-component="frame" data-type="frame" style="display: table-row;" data-asset-id={image.assetId}>
      //         <div className="img" data-original-bg-img={util.getUploadedImgSrc(image)} style={`width: 100%; height: 100%;`}>
      //           <picture>
      //             <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={util.getUploadedImgSrc(image)} alt={image.altText} />
      //           </picture>
      //         </div>

      //         <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
      //           <div className="dropdown menu-container">
      //             <div 
      //               className="dropdown-toggle menu-toggle"
      //               onClick={this.handleMenuToggle}
      //             >
      //               <EllipsisOutlined/>
      //             </div>
      //             <div className="dropdown-menu">
      //               <ul>
      //                 <li onClick={(event) => this.openCropper(image, event)}>
      //                   <CropImageIcon/> Crop Photo
      //                 </li>
      //                 <li onClick={(event) => this.openAltTextModal(image, event)}>
      //                   <ADAIcon color="#000"/> ADA Text
      //                 </li>
      //                 <li onClick={(event) => this.removeImage(image, event)}>
      //                   <DeleteOutlined/> Delete
      //                 </li>
      //               </ul>
      //             </div>
      //           </div>
      //         </div>

      //         <FavoriteButton assetId={image.id} type="upload" />
      //       </div>
      //     </div>
      //   )
      // }
    });

    const imageElements = (<Masonry updateOnEachImageLoad={false} className={'masonry-grid'}>
      {elements}
    </Masonry>);

    const cropperFooterElement = state.isUploadLoading ? <Spinner small={true} /> :
      <div className="footer">
        <a className="btn primary pull-right accept" onClick={() => this.cropImage()}>Crop</a>
        <a className="btn tertiary pull-right" onClick={() => this.closeCropper()}>Cancel</a>
      </div>;

    const cropperElement = state.isCropping ?
      <div className="upload-cropper">
        <div className="container">
          <Cropper
            ref={cropper => {
              this.cropper = cropper;
            }}
            src={state.imageCropSrc}
            style={{ height: 300, width: 'auto' }}
            guides={true}
            zoomable={false}
            background={false}
            viewMode={2}
            checkCrossOrigin={false}
          />
        </div>

        {cropperFooterElement}
      </div>
      : '';

    util.nextTick(() => {
      const uploadedVideos = $("#app-aside-uploads video");
      uploadedVideos.each(function (index, video) {
        // onmouseover="this.play()" onmouseout="this.pause();this.currentTime=0;"

        $(video).off("mouseover mouseout loadedmetadata");
        $(video).on("mouseover", function () {
          this.muted = true;
          this.play();
        });

        $(video).on("mouseout", function () {
          this.pause();
        });

        $(video).on("loadedmetadata", function () {
          $(this).parent().append(`
            <div class="video-info">
              <span className="duration">${moment.utc(this.duration * 1000).format('mm:ss')}</span>
            </div>
            `
          )
        });
      });
    });

    return (
      <div id="app-aside-uploads" className="aside-text aside-uploads" >
        {cropperElement}
        < div className="to-root" >
          <a onClick={() => props.goToRoot()}>
            All graphics
          </a>
          <span className="path">&gt;&nbsp; Uploads</span>
        </div>

        <div className="dropbox">
          {uploadBox}
          {uploadErrorMessage}
        </div>

        {this.props.uploadedImages && this.props.uploadedImages.length > 1 &&
          <div className="organize-uploads">
            <button className="btn secondary1" onClick={() => this.openOrganizeUploadsModal()}>
              Manage Images
            </button>
          </div>
        }

        <div className={"scroller"}>
          {imageLoadingSpinner}
          <div className="components images">
            {imageElements}
          </div>
        </div>

        {props.isOrganizeUploadsModal &&
          <OrganizeUploadsModal
            open={props.isOrganizeUploadsModal}
            onClose={this.closeOrganizeUploadsModal}
            loadedImages={state.loadedImages}
            openAltTextModal={this.openAltTextModal}
            openCropper={this.openCropper}
            removeImage={this.removeImage}
            setUploadedImages={this.props.setUploadedImages}
            uploadedImages={this.props.uploadedImages}
          />}
      </div >
    )
  }
}
